import { useState } from "react";
import axios from "axios";
import provinces from "../utils/Province";
import { sanitizeText } from "../utils/TextUtils";
import { toast } from "react-toastify";
import "./webform.css";

const WebForm = () => {
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone_number: "",
        restaurant_name: "",
        province: "",
    });

    const [formErrors, setFormErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone_number") {
            const sanitizedValue = value.replace(/\D/g, "");
            setFormData({
                ...formData,
                [name]: sanitizedValue,
            });
        } else {
            setFormData({
                ...formData,
                [name]: sanitizeText(value),
            });
        }

        setFormErrors({ ...formErrors, [name]: "" });
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.name) {
            errors.name = "Il Tuo Nome non può essere vuoto.";
        }
        if (!formData.email) {
            errors.email = "E-mail non può essere vuoto.";
        } else if (!validateEmail(formData.email)) {
            errors.email = "Inserire un indirizzo e-mail valido.";
        }
        if (!formData.phone_number) {
            errors.phone_number = "Telefono non può essere vuoto.";
        }
        if (!formData.restaurant_name) {
            errors.restaurant_name = "Nome Locale non può essere vuoto.";
        }
        if (!formData.province) {
            errors.province = "Provincia italiana non può essere vuoto.";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log(formData)
        const isFormValid = validateForm();
        if (!isFormValid) return;

        try {
            const submissionData = new FormData();
            submissionData.append("name", formData.name || "");
            submissionData.append("email", formData.email || "");
            submissionData.append("phone_number", formData.phone_number || "");
            submissionData.append("restaurant_name", formData.restaurant_name || "");
            submissionData.append("region", formData.province || "");

            const response = await axios.post(
                `${apiUrl}/api/v1/store-contact`,
                submissionData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            if (response.status === 200 || response.status === 201) {
                setFormData({
                    name: "",
                    email: "",
                    phone_number: "",
                    restaurant_name: "",
                    province: "",
                });
                toast.success(response.data.message || "Form submitted successfully!", {
                    theme: 'colored',
                    autoClose: 1000,
                });
            } else {
                toast.error("Submission failed. Please try again.", {
                    theme: 'colored',
                    autoClose: 1000,
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An error occurred while submitting. Please try again.");
        }
    };

    return (
        <>
            <div
                id="authentication-modal"
                className="flex justify-center items-center w-full h-full"
            >
                <div
                    className="max-w-[440px] w-full px-[20px]"
                    tabIndex="-1"
                    aria-hidden="false"
                >
                    <div className="relative">
                        <div id="crmWebToEntityForm" className="zcwf_lblTopBottom crmWebToEntityForm border-[#2274a5] border-[2px]" style={{ backgroundColor: "white", color: "black", padding: "25px" }}>
                            <form id="webform133010000060077001" onSubmit={handleSubmit}>
                                {/* Name */}
                                <div className="zcwf_row">
                                    <div className="zcwf_col_lab" style={{ fontSize: "12px", fontFamily: "Arial" }}>
                                        <label htmlFor="Last_Name">Nome<span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    <div className="zcwf_col_fld">
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            aria-required="true"
                                            maxLength="80"
                                        />
                                        {formErrors.name && <div style={{ color: "red", fontSize: "12px" }}>{formErrors.name}</div>}
                                    </div>
                                </div>

                                {/* Email */}
                                <div className="zcwf_row">
                                    <div className="zcwf_col_lab" style={{ fontSize: "12px", fontFamily: "Arial" }}>
                                        <label htmlFor="Email">E-mail<span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    <div className="zcwf_col_fld">
                                        <input
                                            type="text"
                                            id="Email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            aria-required="true"
                                            maxLength="100"
                                        />
                                        {formErrors.email && <div style={{ color: "red", fontSize: "12px" }}>{formErrors.email}</div>}
                                    </div>
                                </div>

                                {/* phone_number */}
                                <div className="zcwf_row">
                                    <div className="zcwf_col_lab" style={{ fontSize: "12px", fontFamily: "Arial" }}>
                                        <label htmlFor="phone_number">Telefono<span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    <div className="zcwf_col_fld">
                                        <input
                                            type="text"
                                            id="phone_number"
                                            name="phone_number"
                                            value={formData.phone_number}
                                            onChange={handleInputChange}
                                            aria-required="true"
                                            maxLength="30"
                                        />
                                        {formErrors.phone_number && <div style={{ color: "red", fontSize: "12px" }}>{formErrors.phone_number}</div>}
                                    </div>
                                </div>

                                {/* Local Name */}
                                <div className="zcwf_row">
                                    <div className="zcwf_col_lab" style={{ fontSize: "12px", fontFamily: "Arial" }}>
                                        <label htmlFor="LEADCF3">Nome Locale<span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    <div className="zcwf_col_fld">
                                        <input
                                            type="text"
                                            id="LEADCF3"
                                            name="restaurant_name"
                                            value={formData.restaurant_name}
                                            onChange={handleInputChange}
                                            aria-required="true"
                                            maxLength="255"
                                        />
                                        {formErrors.restaurant_name && <div style={{ color: "red", fontSize: "12px" }}>{formErrors.restaurant_name}</div>}
                                    </div>
                                </div>

                                {/* Province */}
                                <div className="zcwf_row">
                                    <div className="zcwf_col_lab" style={{ fontSize: "12px", fontFamily: "Arial" }}>
                                        <label htmlFor="LEADCF21">Provincia<span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    <div className="zcwf_col_fld">
                                        <div>
                                            <select
                                                id="LEADCF21"
                                                name="province"
                                                value={formData.province}
                                                onChange={handleInputChange}
                                                aria-required="true"
                                            >
                                                {provinces.map((province, index) => (
                                                    <option key={index} value={province.value}>
                                                        {province.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {formErrors.province && <div style={{ color: "red", fontSize: "12px" }}>{formErrors.province}</div>}
                                        </div>
                                    </div>
                                </div>

                                {/* Submit and Reset Buttons */}
                                <div className="zcwf_row">
                                    <div className="zcwf_col_lab"></div>
                                    <div className="zcwf_col_fld">
                                        <button type="submit" className="formsubmit zcwf_button">
                                            Invia
                                        </button>
                                        {/* <button type="reset" className="zcwf_button" onClick={handleReset} >
                                            Ripristina
                                        </button> */}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WebForm;
